import { Directive } from "vue";

// v-reveal="150" → aparece con 150ms de retraso cuando entra al viewport
// Modificadores opcionales: v-reveal.left / .right / .zoom
const observer =
  typeof IntersectionObserver !== "undefined"
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-visible");
              observer?.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
      )
    : null;

const reveal: Directive<HTMLElement, number | undefined> = {
  mounted(el, binding) {
    el.classList.add("reveal");
    Object.keys(binding.modifiers).forEach((m) =>
      el.classList.add(`reveal-${m}`)
    );
    if (binding.value)
      el.style.setProperty("--reveal-delay", `${binding.value}ms`);
    if (observer) observer.observe(el);
    else el.classList.add("is-visible");
  },
  unmounted(el) {
    observer?.unobserve(el);
  },
};

export default reveal;
